import React from 'react';
import ATable from '../../common/table';

const MerchantDisputantsTable = (props) => {


    const columns = [{
        header: "S/N",
        width: 50,
        render: row => (<div>{row.viewIndex + 1}</div>)
    },
    {
        header: "Domain Code",
        accessor: "domainCode"
    },
    {
        header: "Domain Name",
        accessor: "domainName",
    }
    
   
    ];
    return (
        <ATable
            className="-striped -highlight"
            tableData={props.merchantDisputants}
            columns={columns}
            onChange={props.onTableChange || null}
            manual
            {...props} />
    )
};

export default MerchantDisputantsTable;


// WEBPACK FOOTER //
// ./src/components/admin/merchantDisputants/merchantDisputantsTable.js